import { GET } from './executer';
import apiServiceInstance from './apiService';
import type { EventSource } from './eventsService';

/**
 * Event info entity
 */
export interface EventInfo {
  season_year: number;
  circuit_id: string;
  start_date: string;
  info_text: string;
  value_date: string;
  created_at: string;
}

interface GetInfosParams {
  season_year: number;
  circuit_id: string;
  start_date: string;
  source?: EventSource;
}

/**
 * Service for fetching event system information messages
 */
class InfosService {
  /**
   * Fetch infos for a specific event using composite key
   * @param params Event parameters including season_year, circuit_id, start_date, and source
   */
  async getEventInfos(params: GetInfosParams) {
    const { season_year, circuit_id, start_date, source = 'prod' } = params;
    
    const queryParams = new URLSearchParams({ source });
    const url = `/api/infos/${season_year}/${circuit_id}/${start_date}?${queryParams.toString()}`;
    
    return await apiServiceInstance.client.execute<EventInfo[]>(
      GET,
      url
    );
  }

  /**
   * Format timestamp for display in the circuit's local timezone
   * @param timestamp ISO 8601 UTC timestamp
   * @param timeZone IANA timezone (e.g., "Europe/Rome", "America/New_York")
   */
  formatTimestamp(timestamp: string, timeZone?: string): string {
    const date = new Date(timestamp);
    
    // If no timezone provided, use browser's local time (fallback)
    if (!timeZone) {
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
    }
    
    // Format in the circuit's timezone
    return date.toLocaleString('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }
}

const infosServiceInstance = new InfosService();
export default infosServiceInstance;

